import { IconButton } from "@carbon6/c6-frontend-design";
import type { AdminDiagnosticCapacity } from "@/api/adminDiagnosticJob";
import { EmptyState } from "@/shared/ui/emptyState/public";
import styles from "./DiagnosticCapacityStrip.module.css";

/** 클러스터 후보 순서를 유지하고 현재 조직에서 열 수 있는 상세만 연결한다. */
export function DiagnosticCapacityStrip({
  capacity,
  onOpenJob,
}: {
  capacity: AdminDiagnosticCapacity | null;
  onOpenJob: (jobUuid: string) => void;
}) {
  if (capacity === null) return null;
  return (
    <section className={styles.strip} aria-label="진단 처리량">
      <div className={styles.facts}>
        <span>
          실행 구간 {capacity.video_windows.live} / 상한 {capacity.video_windows.limit}
        </span>
        <span>
          진단 Worker {capacity.workers.online} · 작업 중 {capacity.workers.busy}
        </span>
        {capacity.video_windows.live >= capacity.video_windows.limit && (
          <span className={styles.condition}>영상 실행 상한 도달</span>
        )}
        {capacity.non_video_pending > 0 && (
          <span className={styles.condition}>
            비영상 우선 배정 후보 {capacity.non_video_pending}개
          </span>
        )}
      </div>
      <div className={styles.heading}>
        <strong>영상 구간 배정 후보</strong>
        <span className={styles.note}>
          클러스터 전체 · 요청 시각순 · 실제 배정은 달라질 수 있습니다.
        </span>
      </div>
      {capacity.next.length === 0 ? (
        <EmptyState size="sm" mode="plain">
          구간을 기다리는 video 작업이 없습니다.
        </EmptyState>
      ) : (
        <ol className={styles.nextList}>
          {capacity.next.map((job, index) => (
            <li className={styles.next} key={job.job_uuid}>
              <span className={styles.ordinal}>{index + 1}</span>
              <span className={styles.name}>
                {job.can_open_detail ? (
                  <IconButton
                    text={job.dataset_display_name}
                    size="sm"
                    variant="ghost"
                    onClick={() => onOpenJob(job.job_uuid)}
                  />
                ) : (
                  <span>
                    {job.dataset_display_name}{" "}
                    <span className={styles.note}>· 다른 조직 · 상세 열기 불가</span>
                  </span>
                )}
              </span>
              <span className={styles.running}>실행 구간 {job.running_windows}</span>
              <span className={styles.allocation}>
                {[
                  job.total_final ? "할당 끝" : "새 구간 배정 대상",
                  job.has_reclaimable_windows ? "반납·만료 구간 재배정 대상" : null,
                ]
                  .filter(Boolean)
                  .join(" · ")}
              </span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
